function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var $df1d8e967e73ec8e$exports = require("./utils.main.js");
var $iASLq$internationalizeddate = require("@internationalized/date");
var $iASLq$react = require("react");
var $iASLq$reactariautils = require("@react-aria/utils");
var $iASLq$reactariai18n = require("@react-aria/i18n");
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {
    get: v,
    set: s,
    enumerable: true,
    configurable: true
  });
}
$parcel$export(module.exports, "useCalendarGrid", function () {
  return $a07388a797d86b95$export$cb95147730a423f5;
});
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

function $a07388a797d86b95$export$cb95147730a423f5(props, state) {
  var _props$startDate = props.startDate,
    startDate = _props$startDate === void 0 ? state.visibleRange.start : _props$startDate,
    _props$endDate = props.endDate,
    endDate = _props$endDate === void 0 ? state.visibleRange.end : _props$endDate;
  var _ref = (0, $iASLq$reactariai18n.useLocale)(),
    direction = _ref.direction;
  var onKeyDown = function onKeyDown(e) {
    switch (e.key) {
      case 'Enter':
      case ' ':
        e.preventDefault();
        state.selectFocusedDate();
        break;
      case 'PageUp':
        e.preventDefault();
        e.stopPropagation();
        state.focusPreviousSection(e.shiftKey);
        break;
      case 'PageDown':
        e.preventDefault();
        e.stopPropagation();
        state.focusNextSection(e.shiftKey);
        break;
      case 'End':
        e.preventDefault();
        e.stopPropagation();
        state.focusSectionEnd();
        break;
      case 'Home':
        e.preventDefault();
        e.stopPropagation();
        state.focusSectionStart();
        break;
      case 'ArrowLeft':
        e.preventDefault();
        e.stopPropagation();
        if (direction === 'rtl') state.focusNextDay();else state.focusPreviousDay();
        break;
      case 'ArrowUp':
        e.preventDefault();
        e.stopPropagation();
        state.focusPreviousRow();
        break;
      case 'ArrowRight':
        e.preventDefault();
        e.stopPropagation();
        if (direction === 'rtl') state.focusPreviousDay();else state.focusNextDay();
        break;
      case 'ArrowDown':
        e.preventDefault();
        e.stopPropagation();
        state.focusNextRow();
        break;
      case 'Escape':
        // Cancel the selection.
        if ('setAnchorDate' in state) {
          e.preventDefault();
          state.setAnchorDate(null);
        }
        break;
    }
  };
  var visibleRangeDescription = (0, $df1d8e967e73ec8e$exports.useVisibleRangeDescription)(startDate, endDate, state.timeZone, true);
  var _get = (0, $df1d8e967e73ec8e$exports.hookData).get(state),
    ariaLabel = _get.ariaLabel,
    ariaLabelledBy = _get.ariaLabelledBy;
  var labelProps = (0, $iASLq$reactariautils.useLabels)({
    'aria-label': [ariaLabel, visibleRangeDescription].filter(Boolean).join(', '),
    'aria-labelledby': ariaLabelledBy
  });
  var dayFormatter = (0, $iASLq$reactariai18n.useDateFormatter)({
    weekday: props.weekdayStyle || 'narrow',
    timeZone: state.timeZone
  });
  var _ref2 = (0, $iASLq$reactariai18n.useLocale)(),
    locale = _ref2.locale;
  var weekDays = (0, $iASLq$react.useMemo)(function () {
    var weekStart = (0, $iASLq$internationalizeddate.startOfWeek)((0, $iASLq$internationalizeddate.today)(state.timeZone), locale);
    return _toConsumableArray(new Array(7).keys()).map(function (index) {
      var date = weekStart.add({
        days: index
      });
      var dateDay = date.toDate(state.timeZone);
      return dayFormatter.format(dateDay);
    });
  }, [locale, state.timeZone, dayFormatter]);
  return {
    gridProps: (0, $iASLq$reactariautils.mergeProps)(labelProps, {
      role: 'grid',
      'aria-readonly': state.isReadOnly || undefined,
      'aria-disabled': state.isDisabled || undefined,
      'aria-multiselectable': 'highlightedRange' in state || undefined,
      onKeyDown: onKeyDown,
      onFocus: function onFocus() {
        return state.setFocused(true);
      },
      onBlur: function onBlur() {
        return state.setFocused(false);
      }
    }),
    headerProps: {
      // Column headers are hidden to screen readers to make navigating with a touch screen reader easier.
      // The day names are already included in the label of each cell, so there's no need to announce them twice.
      'aria-hidden': true
    },
    weekDays: weekDays
  };
}